import { gql } from '@apollo/client'

import { LOCATION_FRAGMENT } from '@/graphql'

export const GET_TENANT_STORES_SIMPLE = gql`
  query GetTenantStoresSimple(
    $filters: StoreFilter
    $order: StoreOrder
    $pagination: OffsetPaginationInput
  ) {
    tenantStores(filters: $filters, order: $order, pagination: $pagination) {
      totalCount
      results {
        id
        inactiveAt
        location {
          ...Location
        }
      }
    }
  }
  ${LOCATION_FRAGMENT}
`
